export const RESOURCE = 'adminpartneraccount';
export const ACTIONS = { Get: '', GetSummary: '/summary', Update: '', Create: '' }